import React from 'react';

function UserProfile() {
  return (
    <div className="user-profile">
      <img src="https://via.placeholder.com/50" alt="User" className="user-avatar" />
      <span className="user-name">John Doe</span>
    </div>
  );
}

export default UserProfile;